import { Parser } from "json2csv";
import React, { FC, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import { searchEsProduct } from "../../../api";
import { ProductModel } from "../../../models";
import { useAsync } from "../../../utils";

enum outputHeadersEnum {
	medigoId = "ID sản phẩm",
	name = "Tên sản phẩm",
	loai = "Phân nhóm",
	phan_loai = "Phân loại {replaceMe}",
	nsx = "NHÀ SẢN XUẤT",
	pkgName = "Loại đóng gói",
    pkgId = "ID đóng gói"
}

const ProductsDownload: FC = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	// const [isComplete, setIsComplete] = useState<boolean>(false);

	let isComplete = false;

	const [loadingPercent, setLoadingPercent] = useState<number>(0);

	const [isSuccess, setIsSuccess] = useState<boolean>(false);
	const [outRows, setOutRows] = useState<any[]>([]);

	const searchProductAsync = useAsync(searchEsProduct);

	const getQuery = (offset: number, limit: number) => {
		return {
			from: offset,
			size: limit,
		};
	};

	const handleSeach = async (offset: number, limit: number) => {
		try {
			let res = await searchProductAsync.execute(getQuery(offset, limit));

			console.log("res.total: ", res.total);
			console.log("offset: ", offset);
			if (res.total < offset + limit) {
				isComplete = true;
			}

			setLoadingPercent(Math.floor((offset * 100) / res.total));

			return res.data;
		} catch (err) {
			console.log("error: ", err);
		}
	};

	const onDownloadClick = async () => {
		if (isLoading) {
			return;
		}

		setIsLoading(true);

		let limit = 100;
		let offset = 0;

		let outRows: any[] = [];

		while (!isComplete) {
			console.log("isComplete: ", isComplete);

			let products: ProductModel[] = await handleSeach(offset, limit);

			if (products) {
				let totalItems = products.length;

				for (let i = 0; i < totalItems; ++i) {
					const product = products[i];
					console.log("product: ", product);

					for (let j = 0; j < product.dong_goi.length; j++) {
						let row: any = {};
						
						// File tải bao gồm tất cả các đơn vị đóng gói: Ví dụ Sản phẩm Efferalgan có đơn vị hộp, vỉ, viên. Kho hiện tại chỉ nhập giá hộp, vỉ khi export file chỉ có dòng giá hộp, vỉ >> muốn export ra cả dòng giá viên để NT biết có thể nhập thêm giá viên của sp Efferalgan.
                        // if (!product.dong_goi[j].duoc_ban_le) continue;

						row[outputHeadersEnum.medigoId] = product.sku_id;
						row[outputHeadersEnum.name] = product.name;

						// Get category name
						row[outputHeadersEnum.loai] = product.loai;
                        row[outputHeadersEnum.pkgName] = product.dong_goi[j].loai_dong_goi?.name || "";
                        row[outputHeadersEnum.pkgId] = product.dong_goi[j].loai_dong_goi?.id || "";

						if (
							product.nha_cung_cap.length > 0 &&
							product.nha_cung_cap[0].nha_san_xuat
						) {
							row[outputHeadersEnum.nsx] =
								product.nha_cung_cap[0].nha_san_xuat.name;
						} else {
							row[outputHeadersEnum.nsx] = "";
						}

						// For each phan_loais
						for (let j = 0; j < product.phan_loais.length; j++) {
							row[
								replaceString(
									outputHeadersEnum.phan_loai,
									(j + 1).toString()
								)
							] = product.phan_loais[j].name;
						}
						outRows.push(Object.assign({}, row));
					}
				}
			}

			offset += limit;
		}
		setOutRows(outRows);

		setIsLoading(false);
		setIsSuccess(true);
	};

	const replaceString = (str: string, value: string): string => {
		return str.replace("{replaceMe}", value);
	};

	const getDisableClass = () => {
		if (isLoading) {
			return "disabled";
		}

		return "";
	};

	const downloadFile = () => {
		let parser = new Parser();
		let csv = parser.parse(outRows);

		var blob = new Blob([csv], { type: "text/csv;charset=utf8;" });

		var uri = "data:attachment/csv;charset=utf-8," + encodeURI(csv);
		var link = document.createElement("a");
		link.href = URL.createObjectURL(blob);
		link.setAttribute("visibility", "hidden");
		// link.download = selectedFile.name;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<div>
			<LoadingOverlay
				active={isLoading}
				spinner
				text={"Đang xử lý ... " + loadingPercent + "%"}
				fadeSpeed={500}
			>
				{isLoading ? <div className="overlay-wrapper"></div> : ""}
			</LoadingOverlay>

			{isSuccess && outRows.length > 0 ? (
				<div className="text-center mt-5 text-success">
					Xử lý dữ liệu thành công
					<button className="btn m-3 px-3" onClick={downloadFile}>
						Tải file
					</button>
				</div>
			) : (
				""
			)}

			{isSuccess && outRows.length == 0 ? (
				<div className="text-center mt-5 text-success">
					Không có dữ liệu của nhà thuốc
				</div>
			) : (
				""
			)}

			<div className="fixed-button">
				<a
					onClick={(e) => {
						e.preventDefault();
						onDownloadClick();
					}}
					className={`btn btn-block ${getDisableClass()}`}
					href="/#"
				>
					XỬ LÝ DỮ LIỆU
				</a>
			</div>
		</div>
	);
};

export default ProductsDownload;
